import { forwardRef } from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';
import { useIsMobile } from 'hooks/useIsMobile';
import Icon from '../icon';

const StyledButton = styled.button`
  padding: 6px;
  background-color: ${colors.addBtnBg};
  border: none;
  outline: none;
  border-radius: 50%;
`;

interface IAddButton {
  id?: string;
  onClick?: () => void;
  cypressAttribute?: string;
  styles?: string;
}

const AddButton = forwardRef<HTMLElement, IAddButton>(
  ({ id, onClick, cypressAttribute, styles }, ref) => {
    const isMobile = useIsMobile();
    return (
      <StyledButton id={id} onClick={onClick} className={styles} data-cy={cypressAttribute}>
        <Icon size={isMobile ? 'small' : 'medium'} icon="PlusIcon" stroke={colors.orange} />
      </StyledButton>
    );
  }
);

export default AddButton;
